import * as actionTypes from './actionTypes'

// Fetch

export const fetchReportTransportInvoicing = filters => ({
    type: actionTypes.FETCH,
    payload: {
        filters,
    },
})

export const fetchReportTransportInvoicingFulfilled = data => ({
    type: actionTypes.FETCH_FULFILLED,
    payload: {
        data,
    },
})

export const fetchReportTransportInvoicingRejected = message => ({
    type: actionTypes.FETCH_REJECTED,
    payload: message,
})

export const fetchReportTransportInvoicingCancelled = () => ({
    type: actionTypes.FETCH_CANCELLED,
})

// Clear

export const clearReportTransportInvoicing = () => ({
    type: actionTypes.CLEAR,
})

// Set transport prices

export const setTransportPrices = (transportIds, priceForKm, priceFix, erasePriceToll, source, transportsIds) => ({
    type: actionTypes.SET_TRANSPORT_PRICES,
    payload: {
        transportIds,
        priceForKm,
        priceFix,
        erasePriceToll,
        source,
        transportsIds
    },
})

export const setTransportPricesFulfilled = data => ({
    type: actionTypes.SET_TRANSPORT_PRICES_FULFILLED,
    payload: {
        data,
    },
})

export const setTransportPricesRejected = message => ({
    type: actionTypes.SET_TRANSPORT_PRICES_REJECTED,
    payload: message,
})

// Upload transports file

export const uploadTransportsFile = file => ({
    type: actionTypes.UPLOAD_TRANSPORTS_FILE,
    payload: file,
})

export const uploadTransportsFileFulfilled = transportsIds => ({
    type: actionTypes.UPLOAD_TRANSPORTS_FILE_FULFILLED,
    payload: transportsIds,
})

export const uploadTransportsFileRejected = message => ({
    type: actionTypes.UPLOAD_TRANSPORTS_FILE_REJECTED,
    payload: message,
})

export const uploadTransportsFileCancelled = () => ({
    type: actionTypes.UPLOAD_TRANSPORTS_FILE_CANCELLED,
})